import {svgIconWrapper} from '../svg-icon-wrapper';

import LeadRegularPlus from './lead-regular-plus-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <LeadRegularPlus {...props} />;
}
SvgComponent.iconName = 'leadRegularPlus';

export const LeadRegularPlusIcon = svgIconWrapper(SvgComponent);
